import el from '@finn-no/create-element';

export default {
    dependencies: ['$element', 'xhrservice', 'templateservice', 'radio'],
    callable(ele, xhr, templateservice, radio) {
        if (ele.querySelector('[data-no-ads-at-all]')) {
            return false;
        }
        const adsContainer = ele.querySelector('[data-ads-container]');
        const nohitsEl = ele.querySelector('[data-nohits]');
        const errorFetchingAdsEl = ele.querySelector(
            '[data-error-fetching-ads]'
        );
        const spinnerEl = ele.querySelector('[data-spinner]');
        const url = '/user/myAllAds.json?';
        const allAdsText = 'Alle annonsetyper';
        const statusTranslator = {
            drafted: 'påbegynte',
            active: 'aktive',
            inactive: 'utgåtte',
        };
        const currentHitcount = document.querySelector('[data-counter-prop]');
        const userAdtypes = {};
        let draftedAds;
        let activeAds;
        let inactiveAds;
        let draftedAdtypeCount;
        let activeAdtypeCount;
        let inactiveAdtypeCount;
        radio('on-filter-changed').subscribe(onFilterChanged);

        init();

        function init() {
            const reloadEl = ele.querySelector('[data-page-reload]');
            if (reloadEl) {
                reloadEl.addEventListener('click', () => {
                    document.location.reload(true);
                });
            }
            setupFiltercountAndCache();
        }

        function setupFiltercountAndCache() {
            const types = ['drafted', 'active', 'inactive'];
            const adLists = types.map(type => fetchAds('all', type));
            showSpinner();
            Promise.all(adLists).then(
                lists => {
                    const adtypes = Array.from(
                        document.querySelectorAll('[data-adtypes-label-value]')
                    )
                        .filter(
                            label =>
                                label.getAttribute(
                                    'data-adtypes-label-value'
                                ) !== allAdsText
                        )
                        .map(label =>
                            label.getAttribute('data-adtypes-label-value')
                        );

                    if (adtypes.length > 0) {
                        adtypes.forEach(adtype => {
                            userAdtypes[adtype] = 0;
                        });
                    }
                    lists.forEach((list, i) => {
                        if (i === 0) {
                            draftedAds =
                                typeof list.result.draftedAds == 'undefined'
                                    ? []
                                    : list.result.draftedAds;
                            draftedAdtypeCount =
                                draftedAds.length > 0
                                    ? calculateStatusCount(draftedAds)
                                    : userAdtypes;
                        } else if (i === 1) {
                            activeAds =
                                typeof list.result.activeAds == 'undefined'
                                    ? []
                                    : list.result.activeAds;
                            activeAdtypeCount =
                                activeAds.length > 0
                                    ? calculateStatusCount(activeAds)
                                    : userAdtypes;
                        } else if (i === 2) {
                            inactiveAds =
                                typeof list.result.inactiveAds == 'undefined'
                                    ? []
                                    : list.result.inactiveAds;
                            inactiveAdtypeCount =
                                inactiveAds.length > 0
                                    ? calculateStatusCount(inactiveAds)
                                    : userAdtypes;
                        }
                    });
                    if (activeAds.length > 0) {
                        handleAdtypeCount('active');
                        updateTotalCount(activeAds.length);
                        radio('on-filter-changed').broadcast(
                            'Alle annonsetyper',
                            'active'
                        );
                    } else {
                        updateTotalCount(0);
                        handleNohits(allAdsText, 'active');
                    }
                },
                () => {
                    onError();
                }
            );
        }

        function getAds(adtype, status) {
            let listOfAds;

            if (status === 'drafted') {
                listOfAds = draftedAds;
            } else {
                listOfAds = status === 'active' ? activeAds : inactiveAds;
            }

            if (typeof listOfAds == 'undefined') {
                removeSpinner();
                return false;
            }
            const filteredAdsByAdtype =
                adtype === allAdsText
                    ? listOfAds
                    : listOfAds.filter(item => adtype === item.bodyRow[0]);
            if (filteredAdsByAdtype.length === 0) {
                handleNohits(adtype, status);
            }

            let statusType;
            if (status === 'drafted') {
                statusType = 'draftedAds';
            } else {
                statusType = status === 'active' ? 'activeAds' : 'inactiveAds';
            }

            const adsToRender = {};
            adsToRender[statusType] = filteredAdsByAdtype;
            render(adsToRender);
        }

        function handleAdtypeCount(status) {
            let adtypeCount;

            if (status === 'active') {
                adtypeCount = activeAdtypeCount;
            } else {
                adtypeCount =
                    status === 'inactive'
                        ? inactiveAdtypeCount
                        : draftedAdtypeCount;
            }

            radio('on-counters-calculated').broadcast(adtypeCount);
        }

        function onFilterChanged(adtype, status) {
            clearResults();
            showSpinner();
            getAds(adtype, status);
            handleAdtypeCount(status);
        }

        function calculateStatusCount(listOfAds) {
            const ua = Object.assign({}, userAdtypes);
            return listOfAds.reduce((collection, ad) => {
                const market = ad.bodyRow[0];
                collection[market]++;
                return collection;
            }, ua);
        }

        function handleNohits(adtype, status) {
            clearResults();
            removeSpinner();
            nohitsEl.classList.remove('hidden');
            const nohitsText =
                adtype === allAdsText
                    ? `Du har ingen ${statusTranslator[status]} annonser.`
                    : `Du har ingen ${statusTranslator[
                          status
                      ]} annonser på ${adtype}.`;
            nohitsEl.innerHTML = '';
            nohitsEl.appendChild(
                el(
                    'div.centerify',
                    null,
                    el('h2', null, `${nohitsText}`),
                    el(
                        'p',
                        null,
                        el(
                            'span',
                            null,
                            'Dine andre annonser kan du finne ved å endre på filteret. '
                        )
                    ),
                    el(
                        'p',
                        null,
                        // TODO: Use static.finncdn.no
                        el(
                            'img',
                            { src: '/static/images/empty_radiofilter.svg' },
                            null
                        )
                    )
                )
            );
            updateTotalCount(0);
        }

        function render(ads) {
            removeSpinner();
            if (typeof ads.draftedAds !== 'undefined') {
                adsContainer.innerHTML = templateservice.render(
                    'minfinn-drafted-ads',
                    ads
                );
                updateTotalCount(ads.draftedAds.length);
            } else if (typeof ads.activeAds !== 'undefined') {
                adsContainer.innerHTML = templateservice.render(
                    'minfinn-active-ads',
                    ads
                );
                updateTotalCount(ads.activeAds.length);
            } else if (typeof ads.inactiveAds !== 'undefined') {
                adsContainer.innerHTML = templateservice.render(
                    'minfinn-inactive-ads',
                    ads
                );
                updateTotalCount(ads.inactiveAds.length);
            }
        }

        function onError() {
            removeSpinner();
            clearResults();
            errorFetchingAdsEl.classList.remove('hidden');
        }

        function clearResults() {
            adsContainer.innerHTML = '';
            nohitsEl.classList.add('hidden');
        }

        function updateTotalCount(count) {
            currentHitcount.textContent = count;
        }

        function removeSpinner() {
            spinnerEl.classList.add('hidden');
        }

        function showSpinner() {
            spinnerEl.classList.remove('hidden');
        }

        function fetchAds(adtype, status) {
            return xhr
                .request({
                    url: `${url}group=${status}&type=${adtype}`,
                    method: 'GET',
                    type: 'json',
                })
                .then(data => data);
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/myAds.js